/* ============================================
   Kala Curry — Collection Scroll JS
   Handles arrow navigation & click animation
   ============================================ */

(function () {
    'use strict';

    document.querySelectorAll('.section-kc-collection-scroll').forEach(initSection);

    function initSection(section) {
        var track = section.querySelector('[data-scroll-track]');
        var prevBtn = section.querySelector('[data-scroll-prev]');
        var nextBtn = section.querySelector('[data-scroll-next]');
        var clickAnim = section.dataset.clickAnimation === 'true';

        if (!track) return;

        /* --- Arrow navigation --- */
        if (prevBtn && nextBtn) {
            var getScrollAmount = function () {
                var item = track.querySelector('.kc-cs__item');
                return item ? item.offsetWidth * 2 : 300;
            };

            prevBtn.addEventListener('click', function () {
                track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
            });

            nextBtn.addEventListener('click', function () {
                track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
            });

            var updateArrows = function () {
                var scrollLeft = Math.round(track.scrollLeft);
                var maxScroll = track.scrollWidth - track.clientWidth;
                prevBtn.disabled = scrollLeft <= 1;
                nextBtn.disabled = scrollLeft >= maxScroll - 1;
            };

            track.addEventListener('scroll', updateArrows, { passive: true });
            updateArrows();

            /* Re-evaluate on resize */
            var resizeTimer;
            window.addEventListener('resize', function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(updateArrows, 150);
            }, { passive: true });
        }

        /* --- Click animation --- */
        if (clickAnim) {
            track.addEventListener('click', function (e) {
                var item = e.target.closest('.kc-cs__item');
                if (!item) return;
                item.classList.remove('kc-cs__item--clicked');
                /* Force reflow to restart animation */
                void item.offsetWidth;
                item.classList.add('kc-cs__item--clicked');
            });
        }
    }
})();
